import React, { useState, useEffect } from 'react';

import Datatable from '../../../shared/ui/components/Datatable';
import getCustomerTermList from 'src/customer-term/use-cases/getCustomerTermList';

const CustomerTermDatatable = ({ customerId, handleEdit, handleAdd }) => {
  const companyHeadquarterId = localStorage.selectedUserHeadquarter;
  const [list, setList] = useState({
    rows: [],
    count: 0
  });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(100);
  const [orderBy, setOrderBy] = useState({
    columnName: null,
    orderBy: null
  });

  const fetchList = async () => {
    let response = await getCustomerTermList({
      companyHeadquarterId,
      customerId,
      search,
      orderBy: orderBy.columnName
        ? `${orderBy.columnName} ${orderBy.orderBy}`
        : '',
      page,
      limit
    });

    setList(response);
  };

  useEffect(() => {
    fetchList();
  }, [page, limit, search, orderBy]);

  const handleSearch = (searchValue) => {
    setPage(0);
    setSearch(searchValue.target.value);
  };

  const handleChangePage = (pageIndex) => {
    setPage(pageIndex);
  };

  const handleChangeLimit = (limitIndex) => {
    setLimit(limitIndex);
  };

  const handleOrderBy = (column) => {
    setOrderBy(column);
  };

  const handleClickEdit = (event, id) => {
    handleEdit(id);
  };

  const handleClickAdd = (event) => {
    handleAdd();
  };

  const columnNameList = [
    'date',
    'number',
    `{{dateFormat(date, 'MMMM')}}|date`,
    '${CustomerContract.contractCodePrefix}${CustomerContract.contractCode}',
    'amount',
    'CustomerTermStatus.code',
    '${BillingCustomerContact.firstname}${BillingCustomerContact.surnames}|BillingCustomerContact.firstname',
    'BillingCustomerContact.document',
    'detail',
    'totalPrice',
    'rest'
  ];

  return (
    <Datatable
      domainName="CUSTOMER_TERM"
      dataList={list.rows}
      count={list.count}
      addButtonText=""
      addButtonRoute={false}
      title="Cuotas"
      exportExcelButton={Boolean(false)}
      onSearch={handleSearch}
      onChangePageValue={handleChangePage}
      onChangePageLimit={handleChangeLimit}
      handleOrderBy={handleOrderBy}
      handleClickAdd={handleClickAdd}
      handleClickEdit={handleClickEdit}
      rowsPerPage={100}
      columnNameList={columnNameList}
    />
  );
};

export default CustomerTermDatatable;
